import { SWS_HOST } from '@/constants';
import {
  useInformationTranslation,
  InformationTranslation,
} from '../../hooks/useInformationTranslations';
import DataTable from '@components/DataTable';

interface DataStatusProps {
  lastAnalysisUpdateFormattedUTC: string;
  lastAnnualEarninsUpdateFormattedUTC: string;
  lastEarningsUpdateFormattedUTC: string;
  lastEstimatesConfirmationFormattedUTC: string;
  lastEODPriceUpdateFormattedUTC: string;
}

/**
 *
 * @deprecated
 * Replaced by `<FinancialData />` component
 *
 */
const DataStatus = ({
  lastAnalysisUpdateFormattedUTC,
  lastAnnualEarninsUpdateFormattedUTC,
  lastEarningsUpdateFormattedUTC,
  lastEstimatesConfirmationFormattedUTC,
  lastEODPriceUpdateFormattedUTC,
}: DataStatusProps) => {
  const t = useInformationTranslation();
  return (
    <>
      <DataTable>
        <caption>{t('information.financialData.table.caption')}</caption>
        <thead>
          <tr>
            <th>{t('information.financialData.table.heading.data')}</th>
            <th>{t('information.financialData.table.heading.lastUpdated')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t('information.financialData.table.row1')}</td>
            <td>{lastAnalysisUpdateFormattedUTC}</td>
          </tr>
          <tr>
            <td>{t('information.financialData.table.row2')}</td>
            <td>{lastEODPriceUpdateFormattedUTC}</td>
          </tr>
          {lastEstimatesConfirmationFormattedUTC !== 'N/A' && (
            <tr>
              <td>{t('information.financialData.table.row2.5')}</td>
              <td>{lastEstimatesConfirmationFormattedUTC}</td>
            </tr>
          )}
          <tr>
            <td>{t('information.financialData.table.row3')}</td>
            <td>{lastEarningsUpdateFormattedUTC}</td>
          </tr>
          <tr>
            <td>{t('information.financialData.table.row4')}</td>
            <td>{lastAnnualEarninsUpdateFormattedUTC}</td>
          </tr>
        </tbody>
      </DataTable>
      <br />
      <br />
      <p>
        <InformationTranslation i18nKey="information.financialData.disclaimer">
          Unless specified all financial data is based on a yearly period but
          updated quarterly. This is known as Trailing Twelve Month (TTM) or
          Last Twelve Month (LTM) Data. Learn more
          <a
            href={`${SWS_HOST}/help/articles/hc/en-us/articles/115006170908-Why-is-some-of-the-data-on-Simply-Wall-St-different-to-other-sites`}
            rel="nofollow noreferrer noopener"
            target="_blank"
          >
            here
          </a>
          .
        </InformationTranslation>
      </p>
    </>
  );
};

export default DataStatus;
